import {db} from "../../firebase";
import {CompanyMacroAreaI, PartialCompanyMacroAreaI,} from "../../db/models/company/macroArea";
import {getUid} from "../auth";
import {Collections} from "../collections";
import firebase from "firebase/compat/app";
import {CompanyAreaI} from "../../db/models/company/area";
import {getCompanyAreas} from "./index";

export const getCompanyMacroareasListener = (observer: any) => {
    const uid = getUid();
    if (!uid) return;

    return db
        .collection(Collections.COMPANY_MACROAREAS)
        .where("companyId", "==", uid)
        .onSnapshot(observer);
};

export const getCompanyMacroareas = () => {
    const uid = getUid();
    if (!uid) return Promise.reject([]);

    return db
        .collection(Collections.COMPANY_MACROAREAS)
        .where("companyId", "==", uid)
        .get()
        .then((snapshot) => {
            if (!snapshot.docs) return [];
            const macroareas: CompanyMacroAreaI[] = snapshot.docs.map(
                (doc) => doc.data() as CompanyMacroAreaI
            );
            return macroareas;
        });
};

export const addCompanyMacroarea = (
    partialMacroarea: PartialCompanyMacroAreaI
) => {
    const uid = getUid();
    if (!uid) return Promise.reject();

    const macroareaRef = db.collection(Collections.COMPANY_MACROAREAS).doc();
    const macroarea = {
        ...partialMacroarea,
        id: macroareaRef.id,
        companyId: uid
    };

    return macroareaRef.set(macroarea);
};

export const editCompanyMacroarea = (macroarea: CompanyMacroAreaI) => {
    return db
        .collection(Collections.COMPANY_MACROAREAS)
        .doc(macroarea.id)
        .update(macroarea);
};

export const deleteCompanyMacroarea = async (macroareaId: string) => {
    const uid = getUid();
    if (!uid) return Promise.reject();

    // remove macro from areas
    const areas: CompanyAreaI[] = await getCompanyAreas(uid);
    const areasPromises = areas.map((area) =>
        db.collection(Collections.COMPANY_AREAS).doc(area.id).update({
            macroareaId: firebase.firestore.FieldValue.delete(),
        })
    );
    Promise.all(areasPromises);

    // remove macro
    return db
        .collection(Collections.COMPANY_MACROAREAS)
        .doc(macroareaId)
        .delete();
};
